import { FileDownloadResult } from '@mews-commander/data-access';
import { BusinessError } from '@mews/framework';

const REVOKE_DELAY_MS = 60 * 1000; // 60 seconds

const createLinkSource = ({
    contentType,
    fileContentsAsBase64String,
}: {
    contentType: string;
    fileContentsAsBase64String: string;
}) => {
    return `data:${contentType};base64,${fileContentsAsBase64String}`;
};

export const downloadFile = ({ contentType, fileContentsAsBase64String, fileDownloadName }: FileDownloadResult) => {
    if (!contentType || !fileDownloadName || !fileContentsAsBase64String) {
        throw new BusinessError('Missing file parameters');
    }

    const linkSource = createLinkSource({ contentType, fileContentsAsBase64String });
    const downloadLink = document.createElement('a');

    downloadLink.href = linkSource;
    downloadLink.download = fileDownloadName;
    downloadLink.click();

    return { contentType, fileContentsAsBase64String, fileDownloadName };
};

export const openFileInNewTab = async ({ contentType, fileContentsAsBase64String }: FileDownloadResult) => {
    if (contentType == null || fileContentsAsBase64String == null) {
        throw new BusinessError('Missing file parameters');
    }

    const linkSource = createLinkSource({ contentType, fileContentsAsBase64String });
    const response = await window.fetch(linkSource);
    const blob = await response.blob();
    const blobUrl = window.URL.createObjectURL(blob);

    window.open(blobUrl, '_blank');

    window.setTimeout(() => {
        window.URL.revokeObjectURL(blobUrl);
    }, REVOKE_DELAY_MS);
};
